import React, { useContext } from "react";
import { UiStatusService } from "./UiStatusService";

let context: React.Context<UiStatusService>;

export function resetStatus() {
  context = React.createContext<UiStatusService>(
    undefined as unknown as UiStatusService
  );
}

export function getUiStatusContext() {
  if (!context) {
    resetStatus();
  }
  return context;
}

export function useUiStatus() {
  return useContext(getUiStatusContext());
}
